// Manifest of generated PNG assets under public/art/. Generated by
// scripts/generate-art.py and lists every id that has a PNG so the
// renderers can pick PNG-or-SVG-fallback at call time.
const CAPTAINS = new Set([
    'iron', 'doubloon', 'tide', 'hex', 'salt',
    'stormbringer', 'crimson', 'ember', 'wraith',
]);
const SHIPS = new Set([
    'sloop', 'brigantine', 'galleon', 'cutter', 'phantom',
    'frigate', 'schooner', 'manowar', 'leviathan',
]);
const VOYAGES = new Set([
    'calm_seas', 'cursed_tides', 'hoarders_curse',
    'one_shot', 'no_mercy', 'endless_storm',
]);
const CREW = new Set([
    'anchor', 'bilge_pump', 'bilge_rat', 'boarding_hook', 'bosun',
    'cabin_boy', 'carpenter', 'cartographer', 'chronicler', 'cook',
    'cooper', 'coxswain', 'crows_nest', 'cursed_compass', 'cutthroat',
    'dredge', 'drunk_first_mate', 'echo', 'foretelling', 'goldhand',
    'gunner', 'helmsman', 'hexbinder', 'iron_cleaver', 'kraken_banner',
    'last_stand', 'marauder', 'mirror_mage', 'navigator', 'parrot',
    'pillager', 'plague_rat', 'powder_keg', 'powder_monkey', 'quartermaster',
    'saboteur', 'saltbound_surgeon', 'saltwater', 'scribe', 'shipwright',
    'smuggler', 'spy', 'stowaway', 'storm_caller', 'surgeon',
    'tactician', 'tax_collector', 'tideborn_navigator', 'treasurer',
    'vulture', 'watchman',
]);
export function captainImgUrl(id) {
    return CAPTAINS.has(id) ? `/art/captains/${id}.png` : null;
}
export function shipImgUrl(id) {
    return SHIPS.has(id) ? `/art/ships/${id}.png` : null;
}
export function voyageImgUrl(id) {
    return VOYAGES.has(id) ? `/art/voyages/${id}.png` : null;
}
export function crewImgUrl(id) {
    return CREW.has(id) ? `/art/crew/${id}.png` : null;
}
export function uiImgUrl(name) {
    return `/art/ui/${name}.png`;
}
